// Chakra imports
import { Flex } from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import React from "react";

const ActiveUsers = ({ chart }) => {
	return (
		<Card p="16px" mt="4">
			<CardBody>
				<Flex direction="column" w="100%">
					{chart}
				</Flex>
			</CardBody>
		</Card>
	);
};

export default ActiveUsers;
